import { TIER } from "../tier";

import type { CaseOut } from "@platform/api/golden";
import type { ChipStatus } from "@platform/design-system";

export type CaseState = CaseOut["state"];

export const CASE_STATE_LABELS: Readonly<Record<CaseState, string>> = {
  awaiting_refresh: "Waiting for preprod refresh",
  draft: "Draft",
  in_review: "In review",
  golden: TIER,
};

export const CASE_STATE_CHIP_COLORS: Readonly<Record<CaseState, ChipStatus>> = {
  awaiting_refresh: "attention",
  draft: "default",
  in_review: "info",
  golden: "success",
};

/** The longest case label the API accepts (CaseCreate.label in the golden spec). */
export const LABEL_MAX_LENGTH = 1024;
